<template>

  <v-dialog v-model="dialog_invoice" persistent content-class="component_dialog7 inrec__wrapper" id="invoice">
    <v-row class="inrec__wrap">
      <v-col cols="12" class="d-flex align-center justify-space-between header__wrap">
        <div class="h__title">
          <h2>Invoice</h2>
          <p>فاتورة</p>
        </div>
        <div class="h__logo">
          <v-img width="110px" src="@/assets/img/header_logo2.png"></v-img>
          <v-btn class="modal__close__btn" dense @click="$emit('close')"></v-btn>
        </div>
      </v-col>
      <v-col cols="12" class="h__captions__wrap">
        <div class="captions_1">
          <p>{{ $t('common.common.top_desc4') }}</p>
          <p>{{ $t('common.common.top_desc1') }}</p>
        </div>
        <div class="captions_2">
          <p>{{ $t('common.common.office_address') }}</p>
          <p>(202) 279-21291 - (202) 279-21274</p>
          <p>patinfo@egypo.gov.eg</p>
        </div>
      </v-col>

      <v-col cols="12" class="data__title">
        <div>
          <p>{{ $t('component.dialog_invoice.fields.bill_to') }}</p>
          <p>{{ $vuetify.rtl ? companyNameAr : companyNameEn }}</p>
          <p>{{ $vuetify.rtl ? addressAr : addressEn }}</p>
        </div>
        <div></div>
      </v-col>

      <v-col cols="12" class="inrec__list">
        <v-data-table
          :headers="$getHeaderType2(headerTxt, invoiceHeaderEn, invoiceHeaderAr)"
          :items="invoiceList"
          hide-default-footer
          :items-per-page="100"
          class="inrec__type"
          :mobile-breakpoint="MobileBreakPoint"
          disable-sort
        >
          <template v-slot:header.application_no="{ header }">
            {{ $t('component.dialog_invoice.fields.application_no') }}
            <br />
            ({{ $t('component.dialog_invoice.fields.receiving_no') }})
          </template>
          <template v-slot:item.application_no="{ item }">
            <div>{{ item.application_no }}</div>
            <div v-if="item.receipt_no">({{ item.receipt_no }})</div>
          </template>
          <template v-slot:item.name_en="{ item }">
            <div class="text-left">{{ item.name_en }}</div>
          </template>
          <template v-slot:item.name_ar="{ item }">
            <div class="text-right">{{ item.name_ar }}</div>
          </template>
          <template v-slot:item.qty="{ item }">
            <div class="text-right">1</div>
          </template>
          <template v-slot:item.amount="{ item }">
            <div class="text-right">{{ item.amount | comma }}</div>
          </template>
          <template v-slot:item.late_charge_amount="{ item }">
            <div class="text-right">{{ item.late_charge_amount | comma }}</div>
          </template>
          <template v-slot:item.total_amount="{ item }">
            <div class="text-right">{{ item.total_amount | comma }}</div>
          </template>
          <template v-slot:body.append="{ items }">
            <tr>
              <td colspan="7" class="text-right total">{{ $t('component.dialog_invoice.fields.total') }} {{ $t('component.dialog_invoice.fields.amount') }}</td>
              <td class="text-right total">{{ (totalAmount / 100) | comma}}</td>
            </tr>
          </template>
        </v-data-table>
      </v-col>

      <v-col cols="12" class="dojang__wrap">
      </v-col>

      <v-col cols="12" class="d-flex btn__c__wrap">
        <v-btn
          outlined
          rounded
          height="45"
          width="150"
          color="#333"
          @click="fnDownloadInvoicePdf('ar')"
        >{{ $t('common.button.download') }} ({{ $t('common.common.ar') }})</v-btn>
        <v-spacer class="hidden_lr10"></v-spacer>
        <v-btn
          outlined
          rounded
          height="45"
          width="150"
          color="#333"
          @click="fnDownloadInvoicePdf('en')"
        >{{ $t('common.button.download') }} ({{ $t('common.common.en') }})</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          outlined
          rounded
          height="45"
          width="150"
          color="#a01c2a"
          @click="fnPay()"
          :loading="btnPay"
          :disabled="btnPay"
        >
          {{ $t('common.button.pay') }}
          <v-icon right>mdi-credit-card</v-icon>
        </v-btn>
      </v-col>
    </v-row>


    <form name="frmPayment" id="frmPayment" method="POST">
    </form>
  </v-dialog>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import store from '@/store'
import $ from 'jquery'

export default {
  name : "DialogInvoice",
  props : {
    prop_dialog_invoice : {
      type : Boolean,
      default : false
    },
    prop_invoiceList : {
      type : Array
    },
    receipt_no: {
      type: String
    },
    query: {
      type: Object
    }
  },
  components :{
  },
  data () {
    return {
      MobileBreakPoint : 0,
      headerTxt : {
        prefix : 'component.dialog_invoice.fields.',
        txt : [ '#', 'application_no', 'descriptions','invoice_date','qty','rate','late_charge','amount' ]
      },

      invoiceHeaderAr: [
        { text: '#', align: 'center', value: 'no', width: 40, class: 'data_table_header'},
        { text: 'Application No', align: 'center', value: 'application_no', width: 120, class: 'data_table_header' },
        { text: 'Descriptions', align: 'center', value: 'name_ar', class: 'data_table_header' },
        { text: 'Invoice Date', align: 'center', value: 'issued_date', width: 100, class: 'data_table_header'},
        { text: 'Qty', align: 'center', value: 'qty', width: 50, class: 'data_table_header'},
        { text: 'Rate', align: 'center', value: 'amount', width: 80, class: 'data_table_header'},
        { text: 'Late Charge', align: 'center', value: 'late_charge_amount', width: 100, class: 'data_table_header'},
        { text: 'Amount', align: 'center', value: 'total_amount', width: 100, class: 'data_table_header'}
      ],
      invoiceHeaderEn: [
        { text: '#', align: 'center', value: 'no', width: 40, class: 'data_table_header'},
        { text: 'Application No', align: 'center', value: 'application_no', width: 120, class: 'data_table_header' },
        { text: 'Descriptions', align: 'center', value: 'name_en', class: 'data_table_header'},
        { text: 'Invoice Date', align: 'center', value: 'issued_date', width: 100, class: 'data_table_header'},
        { text: 'Qty', align: 'center', value: 'qty', width: 50, class: 'data_table_header'},
        { text: 'Rate', align: 'center', value: 'amount', width: 80, class: 'data_table_header'},
        { text: 'Late Charge', align: 'center', value: 'late_charge_amount', width: 100, class: 'data_table_header'},
        { text: 'Amount', align: 'center', value: 'total_amount', width: 100, class: 'data_table_header'}
      ],
      dialog_invoice: false,
      invoiceList: [],
      companyNameAr: '',
      companyNameEn: '',
      addressAr: '',
      addressEn: '',
      payment: {
        access_code: process.env.VUE_APP_ACCESS_CODE,
        merchant_name: process.env.VUE_APP_MERCHANT_NAME,
        merchant_id: process.env.VUE_APP_MERCHANT_ID,
        payment_url: process.env.VUE_APP_PAYMENT_URL,
        return_url: '',
        version: '1',
        command: 'pay',
        currency: 'EGP',
        locale: 'en',
        secureHash: '',
        transaction_id: null
      },
      result: {
        message: '',
        transactionNo: null,
        txnResponseCode: null
      },

      btnPay: false,

      annuity_policy_config_seq: null,
      fee_policy_config_seq: null
    }
  },
  watch : {
    prop_dialog_invoice() {
      this.dialog_invoice = _.cloneDeep(this.prop_dialog_invoice)
    },
    prop_invoiceList() {
      this.invoiceList = _.cloneDeep(this.prop_invoiceList)
      this.companyNameAr = ''
      this.companyNameEn = ''
      this.addressAr = ''
      this.addressEn = ''
      if (this.invoiceList.length > 0) {
        this.companyNameAr = this.invoiceList[0].company_name_ar
        this.companyNameEn = this.invoiceList[0].company_name_en
        this.addressAr = this.invoiceList[0].address_ar
        this.addressEn = this.invoiceList[0].address_en
        this.annuity_policy_config_seq = this.invoiceList[0].annuity_policy_config_seq
        this.fee_policy_config_seq = this.invoiceList[0].fee_policy_config_seq
      }
    },
    query(val) {
      this.fnSetQuery(val)
    }
  },
  computed: {
    totalAmount() {
      let amount = 0
      this.invoiceList.forEach(item => {
        amount += item.total_amount
      })
      return Math.round(amount * 100)
    },
    paymentList() {
      let payments = []

      this.payments.forEach(item => {
        if (this.paid === 'Y') {
          if (item.ind_paid === 'Y') {
            payments.push(item)
          }
        } else {
          payments.push(item)
        }
      })

      return payments
    }
  },
  filters:{
    comma(val){
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  },
  mounted() {
    this.fnSetQuery(this.$route.query)
  },
  methods: {
    fnDownloadInvoicePdf(lang) {
      let seqs = []
      let group_no = ''
      this.invoiceList.forEach(item => {
        if (item.annuity_policy_config_seq) {
          seqs.push(item.payment_item_seq)
        } else {
          if (group_no !== item.group_no) {
            seqs.push(item.payment_item_seq)
          }
          group_no = item.group_no
        }
      })

      requestApi({
        url: '/file/download/invoices/'+ lang +'?seqs='+ seqs.join('&seqs='),
        method: 'GET',
        responseType: 'blob',
        callback: (res) => {
          if (res.res_code === '401012') {
            utils.setTokenRefresh().then(() => {
              this.fnDownloadInvoicePdf(lang)
            })
          } else {
            const downloadUrl = window.URL.createObjectURL(new Blob([res]))
            const link = document.createElement('a')
            link.href = downloadUrl
            link.setAttribute('download', 'Invoice.pdf')
            document.body.appendChild(link)
            link.click()
            link.remove()
          }
        }
      })
    },

    fnPay() {
      this.btnPay = true

      let seqs = []
      this.invoiceList.forEach(item => {
        seqs.push(item.payment_item_seq)
      })
      let params = {
        payment_item_seq: seqs,
        receipt_no: this.receipt_no
      }
      requestApi({
        url: (this.receipt_no) ? '/receivings/'+ this.receipt_no +'/payment':'/receivings/payment',
        method: 'POST',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            this.payment.transaction_id = res.data.payment_history_seq
            let totalAmount = res.data.total_amount

            let href = document.location.href
            if (href.indexOf('?') > -1 && href.indexOf('vpc_Amount') > -1) {
              let hrefs = href.split('?')[0].split('/')
              this.payment.return_url = hrefs.splice(0, hrefs.length - 1).join('/') +'/'+ this.payment.transaction_id
            } else if (href.indexOf('?') > -1) {
              let hrefs = href.split('?')[0].split('/')
              this.payment.return_url = hrefs.splice(0, hrefs.length).join('/') +'/'+ this.payment.transaction_id
            } else {
              this.payment.return_url = document.location.href +'/'+ this.payment.transaction_id
            }

            // my application detail 에서 결제한 경우
            if (this.payment.return_url.indexOf('/myapplication/view') > -1) {
              if (this.annuity_policy_config_seq) {
                this.payment.return_url += '/annuity'
              } else if (this.fee_policy_config_seq) {
                this.payment.return_url += '/fee'
              }
            }

            if (totalAmount === 0) {
              // 금액이 0 원이면 영수증 생성
              this.fnMakeReceipt(this.payment.transaction_id, false)
            } else {
              this.fnGetSecureHash()
            }
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnPay()
              })
            } else {
              this.btnPay = false
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGetSecureHash() {
      store.dispatch('RequestApi')

      let params = {
        vpc_AccessCode: this.payment.access_code,
        vpc_Amount: this.totalAmount,
        vpc_Command: this.payment.command,
        vpc_Currency: this.payment.currency,
        vpc_Locale: this.payment.locale,
        vpc_MerchTxnRef: this.payment.transaction_id,
        vpc_Merchant: this.payment.merchant_id,
        vpc_OrderInfo: this.payment.transaction_id,
        vpc_ReturnURL: this.payment.return_url,
        vpc_Version: this.payment.version
      }
      requestApi({
        url: '/autho/hmac',
        method: 'POST',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            this.payment.secureHash = res.data.enc

            $('<input>').attr({
                type: 'hidden',
                name: 'vpc_Version',
                value: this.payment.version
            }).appendTo('#frmPayment')

            $('<input>').attr({
                type: 'hidden',
                name: 'vpc_Command',
                value: this.payment.command
            }).appendTo('#frmPayment')

            $('<input>').attr({
                type: 'hidden',
                name: 'vpc_AccessCode',
                value: this.payment.access_code
            }).appendTo('#frmPayment')

            $('<input>').attr({
                type: 'hidden',
                name: 'vpc_MerchTxnRef',
                value: this.payment.transaction_id
            }).appendTo('#frmPayment')

            $('<input>').attr({
                type: 'hidden',
                name: 'vpc_Merchant',
                value: this.payment.merchant_id
            }).appendTo('#frmPayment')

            $('<input>').attr({
                type: 'hidden',
                name: 'vpc_OrderInfo',
                value: this.payment.transaction_id
            }).appendTo('#frmPayment')

            $('<input>').attr({
                type: 'hidden',
                name: 'vpc_Amount',
                value: this.totalAmount
            }).appendTo('#frmPayment')

            $('<input>').attr({
                type: 'hidden',
                name: 'vpc_Currency',
                value: this.payment.currency
            }).appendTo('#frmPayment')

            $('<input>').attr({
                type: 'hidden',
                name: 'vpc_Locale',
                value: this.payment.locale
            }).appendTo('#frmPayment')

            $('<input>').attr({
                type: 'hidden',
                name: 'vpc_ReturnURL',
                value: this.payment.return_url
            }).appendTo('#frmPayment')

            $('<input>').attr({
                type: 'hidden',
                name: 'Title',
                value: this.payment.merchant_name
            }).appendTo('#frmPayment')

            $('<input>').attr({
                type: 'hidden',
                name: 'vpc_SecureHash',
                value: this.payment.secureHash
            }).appendTo('#frmPayment')

            $('<input>').attr({
                type: 'hidden',
                name: 'vpc_SecureHashType',
                value: 'SHA256'
            }).appendTo('#frmPayment')

            $('#frmPayment').attr('action', this.payment.payment_url).submit()
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetSecureHash()
              })
            } else {
              store.dispatch('SetInitRequestApi')
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnSetQuery(val) {
      this.result.message = val.vpc_Message
      this.result.transactionNo = val.vpc_TransactionNo
      this.result.txnResponseCode = val.vpc_TxnResponseCode

      // 결과 페이지인 경우 결과 저장
      if (this.result.txnResponseCode) {
        let notes = JSON.stringify(val)
        let receipt_no = this.receipt_no
        let params = val
        params.notes = notes
        params.payment_history_seq = val.vpc_MerchTxnRef
        params.querystring = document.location.href.split('?')[1]

        if (!receipt_no) receipt_no = this.$route.params.receipt_no

        requestApi({
          url: (receipt_no) ? '/receivings/'+ receipt_no +'/payment': '/receivings/payment',
          method: 'PUT',
          data: params,
          callback: (res) => {
            if (res.res_code === '200') {
              if (this.result.txnResponseCode === '0') {
                // 성공인 경우
                // 영수증 생성
                this.fnMakeReceipt(val.vpc_MerchTxnRef, true)
              } else {
                // 실패인 경우
                let href = this.$route.path.split('/'+ val.vpc_MerchTxnRef)[0]

                let options = {
                  text: this.$t('payment.result.'+ this.result.txnResponseCode) +'<br />'+ this.result.message,
                  path: href,
                  btn: {
                    text: this.$t('common.button.ok')
                  }
                }
                this.$emit('error', options)
              }
            }else {
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnSetQuery(val)
                })
              } else {
                store.dispatch('SetInitRequestApi')
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
              }
            }
          }
        })
      }
    },
    // 영수증 생성
    fnMakeReceipt(paymentHistorySeq, blnPayed) {
      store.dispatch('RequestApi')
      requestApi({
        url: '/receivings/payment/'+ paymentHistorySeq +'/receipt',
        method: 'PUT',
        callback: (res) => {
          store.dispatch('ResponseApi')
          if (res.res_code === '200') {
            this.btnPay = false

            // 성공인 경우
            if (!this.result.txnResponseCode) {
              this.result.txnResponseCode = '0'
              this.result.message = 'Approved'
            }
            let options = {
              text: this.$t('payment.result.'+ this.result.txnResponseCode) +'<br />'+ this.result.message
            }
            eventBus.$emit('SHOW_SNACKBAR', options)

            let href = document.location.href
            if (href.indexOf('/maintenance/payannualfee') > -1) {
              this.dialog_invoice = false
              if (blnPayed) {
                this.$router.replace('/maintenance/payannualfee')
              } else {
                this.$emit('success')
              }
            } else if (href.indexOf('/payment/list') > -1) {
              this.dialog_invoice = false
              if (blnPayed) {
                // 상단 unpayment 개수 업데이트
                eventBus.$emit('PAYMENT_RELOAD')
                this.$router.replace('/payment/list')
              } else {
                this.$emit('success')
              }
            } else if (href.indexOf('/myapplication/view') > -1) {
              // application detail follow-up 에서 결제한 경우
              if (href.indexOf('/annuity') > -1) {
                this.$router.replace('/maintenance/payannualfee')
              } else if (href.indexOf('/fee') > -1) {
                // 상단 unpayment 개수 업데이트
                eventBus.$emit('PAYMENT_RELOAD')
                this.$router.replace('/payment/list')
              }
            } else {
              this.$router.replace('/myrequest/list')
            }
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnMakeReceipt(paymentHistorySeq, blnPayed)
              })
            } else {
              this.btnPay = false
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    }

  }
}
</script>